import { DiTokens } from "../../services/diTokens";
import { NotifyData } from "../../data/notifyData";
import { PersonInfoModel } from "../../models/person/personInfoModel";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import {UserSubscriptionData} from '../../data/UserSubscriptionData';
import ISubscriptionService from "../../services/subscription/ISubscriptionService";
import {DocumentTypeData} from '../../data/DocumentTypeData';
import IPersonService from "../../services/person/IPersonService";
import { container } from "@/inversify.config";
import { getCookie, setCookie } from "../../utilities/cookieHelper";

@Module({
  name: "person",
  namespaced: true
})
export class PersonStore extends VuexModule {

  // services:

  get personService(): IPersonService {
    return container.get<IPersonService>(DiTokens.PersonService);
  }

  get subService(): ISubscriptionService {
    return container.get<ISubscriptionService>(DiTokens.SubscriptionService);
  }

  public get isVip(): boolean {
    return this.personInfo.Data.Vip || getCookie("isVip") == "true";
  }

  /**Данные Пользователя */
  public personInfo: PersonInfoModel = new PersonInfoModel();

  /** Массив уведомлений пользователя */
  public notifyData: Array<NotifyData> = [];

  public newNotifiesCount: number = 0;

  public subscriptions: Array<UserSubscriptionData> = [];

  public userDocTypes: Array<DocumentTypeData> = [];

  /**Признак загрузки */
  public loading: boolean = true;

  public static getDefaultState: Function = () => {
    return {
      personInfo: new PersonInfoModel(),
      loading: true,
      newNotifiesCount: 0,
      notifyData: []  
    }
  };

  /**Установка признака загрузки */
  @Mutation
  setLoading(loading: boolean) {
    this.loading = loading;
  }

  /** Установка подписок */
  @Mutation
  setSubscriptions(subscriptions: Array<UserSubscriptionData>): void {
    this.subscriptions = subscriptions;
  }

  @Mutation
  setDocuments(docs: Array<DocumentTypeData>): void {
    this.userDocTypes = docs;
  }

  @Mutation
  resetStates() {
    Object.assign(this, PersonStore.getDefaultState());
  }

  /** Запись уведомлений */
  @Mutation
  setNotifyData(notyfies: Array<NotifyData>) {
    this.notifyData = notyfies;
  }

  /** Запись личных данных */
  @Mutation
  setPersonInfo(personInfo: PersonInfoModel) {
    this.personInfo = personInfo;
  }

  @Mutation
  public setSbpValues(params: any) {
    this.personInfo.Data.EnableSbpIn = params.sbpIn;
    this.personInfo.Data.EnableSbpOut = params.sbpOut;
  }

  @Mutation setNewNotifyCount() {
    this.newNotifiesCount = this.notifyData.filter((n: NotifyData) => {
      return n.State != 2;
    }).length;
  }

  @Mutation
  setPersonAliasSync(alias: string) {
    if (alias)
      this.personInfo.Data.Alias = alias;
  }

  @Action
  async setPersonAlias(alias: string) {
    this.setLoading(true);
    const res: string | null = await this.personService.setAlias(alias);
    this.setPersonAliasSync(res);
    this.setLoading(false);
  }

  /** Получаем и записываем уведомления */
  @Action
  async fetchNotifications() {
    this.setLoading(true);
    const notyfies = await this.personService.fetchNotificationsData();
    this.setNotifyData(notyfies);
    this.setNewNotifyCount();
    this.setLoading(false);
  }

  /**
   * Получение и запись информации о пользователе
   */
  @Action
  public async fetchPersonInfo() {
    this.setLoading(true);
    const personInfo = await this.personService.fetchPersonInfo();
    setCookie("isVip", personInfo.Data.Vip.toString());
    this.setPersonInfo(personInfo);
    this.setLoading(false);
  }

  /**Изменение аватара пользователя */
  @Action
  async setPersonAvatar(file: any) {
    const base64image = await this.personService.setAvatar(file);
    this.personInfo.Data.Avatar = base64image;
  }

  /** Удаление аватара пользователя */
  @Action
  async removePersonAvatar() {
    const flag: boolean = await this.personService.removeAvatar();
    if (flag)
      this.personInfo.Data.Avatar = '';
  }

  /** Получение подписок */
  @Action
  async fetchSubscriptions(): Promise<void> {
    this.setLoading(true);
    const subs: Array<UserSubscriptionData> = await this.subService.fetchSubscription();
    if (subs)
      this.setSubscriptions(subs);
    this.setLoading(false);
  }

  /** Получение типов документов */
  @Action
  async fetchUserDocumentTypes(): Promise<void> {
    this.setLoading(true);
    const userDocs: Array<DocumentTypeData> = await this.subService.fetchUserDocumentTypes();
    if (userDocs)
      this.setDocuments(userDocs);
    this.setLoading(false);
  }

  @Action
  async deleteSubscription(id: number): Promise<void> {
    this.setLoading(true);
    const subs: Array<UserSubscriptionData> = await this.subService.deleteSubscription(id);
    if (subs)
      this.setSubscriptions(subs);
    this.setLoading(false);
  }
}
